/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ArrowUpRight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.632 4.11a.6.6 0 0 1 .6-.6h5.657a.6.6 0 0 1 .6.6v5.658a.6.6 0 1 1-1.2 0V5.559l-6.754 6.754a.6.6 0 0 1-.848-.848L10.44 4.71H6.232a.6.6 0 0 1-.6-.6Z" clipRule="evenodd" /></svg>;
}
;